import { inscriptionConstants as inscs } from "../../../constants/inscription";

const initialState = { loading: true, list: [], data: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case inscs.GET_INSCRIPTIONS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case inscs.GET_INSCRIPTION:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case inscs.SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
